import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5C728A",
      d: "M12 17a.97.97 0 0 0 .713-.288A.96.96 0 0 0 13 16v-4a.97.97 0 0 0-.288-.713A.96.96 0 0 0 12 11a.97.97 0 0 0-.713.288A.96.96 0 0 0 11 12v4q0 .425.288.713T12 17m0-8a.97.97 0 0 0 .713-.288A.96.96 0 0 0 13 8a.97.97 0 0 0-.288-.713A.96.96 0 0 0 12 7a.97.97 0 0 0-.713.288A.96.96 0 0 0 11 8q0 .425.288.713T12 9m0 13a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.8 9.8 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.8 9.8 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.138 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.138A9.7 9.7 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
    }, null, -1)
  ]))]))
}
export default { render: render }